import * as authentication from './authentication'
import * as externals from './externals'
import * as gardeners from './gardeners'
import * as account from './account'
import * as avanceImmediate from './avanceImmediate'
import * as inquiries from './inquiries'
import * as couponCode from './couponCode'

export default {
  authentication,
  externals,
  gardeners,
  account,
  avanceImmediate,
  inquiries,
  couponCode
}



// WEBPACK FOOTER //
// ./src/api/index.js